import style from '../style.scss'
import { lang } from 'enablex/shared'
import React, { FC, useState, useEffect } from 'react'
import TableContainer from './TableContainer'
import BackIcon from '~/icons/BackIcon'
import api from '~/app/api'
import Select from 'react-select'
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Rectangle
} from 'recharts'

import { AppState } from '~/app/rootReducer'
import { connect, ConnectedProps } from 'react-redux'
import { fetchAgentsStatsData, toggleAnalyticsWindow } from '../reducer'
import { fetchBots } from '~/workspace/bots/reducer'
import PerformanceGraph from './PerformanceGraph'
import PerformancePieChart from './PerformancePieChart'
import StatWidget from '~/workspace/supervisor/dashboard/StatWidget'
import AvgSessionsIcon from '~/icons/AvgSessionsIcon'
import SessionsIcon from '~/icons/SessionsIcon'
import BotIcon from '~/icons/BotIcon'
import LiveAgentsIcon from '~/icons/LiveAgentsIcon'
import PageContainer from '~/app/common/PageContainer'

type Props = {
    isOpen: boolean
    profile?: any
} & ConnectedProps<typeof connector>

function getRandomColor() {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
    }
    return color
}

const ReportingModal: FC<Props> = props => {
  console.log('props ReportingModal',props.profile)

    const [selectedAgentStatsData, setSelectedAgentStatsData]: any = useState([])

    const [AgentList, setAgentList]: any = useState([{ label: 'All Agents', value: 'all' }])
    const [livePerformanceMatrics, setLivePerformanceMatrics] = useState({ linkedAgents: 0, unlinkedAgents: 0, linkedBots: 0, unlinkedBots: 0, avgLiveSessions: 0 })
    const [agentSelected, setAgentSelected] = useState(false)
    const [selectedOption, setSelectedOption] = useState(AgentList[0])
    const [selectedAgentID, setSelectedAgentID] = useState('')
    const [botNames, setBotNames] = useState({})

    // New state for agent dashboard data
    const [agentDashboardData, setAgentDashboardData] = useState({
        totalBots: 0,
        ongoingSessions: 0,
        todaySessionCount: 0,
        lastWeekSessionCount: 0,
        last30DaysSessionCount: 0
    })

    function handleSelectedAgentID(option) {
        if (option.value === 'all') {
            setSelectedAgentID('')
            setAgentSelected(false)
        } else {
            const { id, email } = option.value
            setSelectedAgentID(id)
            setAgentSelected(true)
        }
    }

    const handleOptionSelect = (option) => {
        handleSelectedAgentID(option)
        setSelectedOption(option)
    }

    function formatDate(dateString, dateOnly) {
        if (!dateString) {
            return ''
        }
        let date = new Date(dateString)
        let day = String(date.getUTCDate()).padStart(2, '0')
        let month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are zero-based
        let year = date.getUTCFullYear()
        let formattedDate
        if (dateOnly) {
            // Format the date as dd/mm/yyyy
            formattedDate = `${day}/${month}/${year}`
        } else {
            // Get the hours and minutes components
            let hours = date.getUTCHours()
            let minutes = String(date.getUTCMinutes()).padStart(2, '0')

            // Determine AM/PM and convert hours from 24-hour to 12-hour format
            let period = hours >= 12 ? 'PM' : 'AM'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            let hour = String(hours).padStart(2, '0')

            // Format the date and time as dd/mm/yyyy hh:mm am/pm
            formattedDate = `${day}/${month}/${year} ${hour}:${minutes} ${period}`
        }
        return formattedDate
    }
    console.log('props.agentsStatsData',props.agentsStatsData)
    useEffect(() => {
        if (!props.bots.length) {
            props.fetchBots()
        }

        let agentList: any = [{ label: 'All Agents', value: 'all' }]

        // Live Performance Matrics
        const totalAgents = props.users?.filter(users => users.role === 'agent').length
        // const allAgents = new Set(props.agentsStatsData?.filter(agent => (agent.botId)).map(agent => `${agent.agentId}_${agent.email}`))
        const allAgents = new Set(
          props.agentsStatsData
              ?.filter(agent => agent.email === props.profile?.email)
              .map(agent => `${agent.agentId}_${agent.email}`)
        )
        const linkedAgents = new Set(props.agentsStatsData?.filter(agent => (agent.botId && agent.linkedAgent)).map(agent => `${agent.agentId}_${agent.email}`))
        const linkedAgenstSize = linkedAgents.size
        const linkedBots = new Set(props.agentsStatsData?.filter(agentData => (agentData.botId !== '' && agentData.linkedAgent))).size
        const totalBots = props.bots?.length ? props.bots.length : 0
        const liveSessions = props.agentsStatsData?.reduce((accumulator, item) => {
            return accumulator += item.totalRequests - item.resolvedRequests - item.expiredRequests - item.unassignedRequests
        }, 0)
        const avgLiveSessions = liveSessions && liveSessions > 0 ? liveSessions / linkedAgenstSize : 0

        let livePerformanceMatrics = {
            linkedAgents: linkedAgents.size | 0,
            unlinkedAgents: totalAgents ? totalAgents - linkedAgents.size : 0,
            linkedBots: linkedBots | 0,
            unlinkedBots: totalBots - linkedBots,
            avgLiveSessions
        }

        // console.log('livePerformanceMatrics: ', livePerformanceMatrics)

        setLivePerformanceMatrics((prevState) => {
            return {
                ...prevState,
                ...livePerformanceMatrics
            }
        })
        const selectedAgentID = [...allAgents][0]?.split('_')[0]
        if (selectedAgentID) {
            setSelectedAgentID(selectedAgentID)
            setAgentSelected(true)
        }
        Array.from(allAgents).forEach((data) => {
          const parts = data.split('_')
          const agentId = parts[0]
          const agentEmail = parts.slice(1).join('_') // Handle multiple parts of email
          const formattedLabel = agentEmail.charAt(0).toUpperCase() + agentEmail.slice(1)
          agentList.push({ label: formattedLabel, value: { id: agentId, email: agentEmail } })
        })
        setAgentList(agentList)

        const botMap = props.bots.reduce((map, bot) => {
            map[bot.id] = bot.name
            return map
        }, {})

        setBotNames(botMap)

        // console.log('botNames:: ', botMap)
        // console.log('agentStatsData: ', props.agentsStatsData)
        // console.log('Bots : ', props.bots)
    }, [props.bots])

    // Fetch agent dashboard data
    useEffect(() => {
        const fetchAgentDashboardData = async () => {
            try {
                const { data: agentDashboardResponse } = await api.getSecured().get('/admin/workspace/collaborators/agent/dashboard/stats')
                setAgentDashboardData(agentDashboardResponse.payload)
            } catch (error) {
                console.error('Error fetching agent dashboard data:', error)
                setAgentDashboardData({
                    totalBots: 0,
                    ongoingSessions: 0,
                    todaySessionCount: 0,
                    lastWeekSessionCount: 0,
                    last30DaysSessionCount: 0
                })
            }
        }

        if (props.profile?.email) {
            void fetchAgentDashboardData()
        }
    }, [props.profile?.email])

    useEffect(() => {
        async function fetchData() {
            try {
              console.log('fetchData',selectedAgentID)
                const { data: currentAgentsStatsData } = await api.getSecured().get(`/admin/workspace/collaborators/currentAgentStatsData/${selectedAgentID}`)
                const currentData = currentAgentsStatsData.payload
                // console.log('currentData: ', currentData)
                const agentsData = currentData?.map((data) => {
                    let filteredData = {}
                    const totalRequests = data.resolvedRequests
                    currentAgentHeadingKeys.forEach(key => {
                        if (data.hasOwnProperty(key)) {
                            if (key === 'createdAt' || key === 'firstRequestTime') {
                                filteredData[key] = formatDate(data[key], true)
                            } else if (key === 'lastRequestTime') {
                                filteredData[key] = formatDate(data[key], false)
                            } else if (key === 'resolveTime') {
                                if (totalRequests > 0) {
                                    const timeInSecs = data[key] / totalRequests
                                    filteredData[key] = timeInSecs
                                } else {
                                    filteredData[key] = ''
                                }
                            } else {
                                filteredData[key] = data[key]
                            }
                        }
                    })
                    return filteredData
                }
                )
                setSelectedAgentStatsData(agentsData)
                // console.log('agentsData:: ', agentsData)
            } catch (error) {
            }
        }
        if (agentSelected) {
            void fetchData()
        }
    }, [selectedAgentID])

    // Performance matrics list
    const performanceMatricsList = [
        { label: 'Total Requests', value: 'totalRequests' },
        { label: 'Resolved Requests', value: 'resolvedRequests' },
        { label: 'Unassigned Requests', value: 'unassignedRequests' },
        { label: 'Expired Requests', value: 'expiredRequests' },
        { label: 'Resolve time', value: 'resolveTime' },
        { label: 'Video Sessions', value: 'videoSessions' },
        { label: 'Audio Only Sessions', value: 'audioOnlySessions' },
        { label: 'Voice Sessions', value: 'voiceSessions' }
    ]

    // Performance Pir chart list
    const performancePieChartList = {
        'resolvedRequests': 'Resolved Requests',
        'resolveTime': 'Resolve Time'
    }

    //Bot Name in heading have id as botId
    const currentAgentHeading = [
        'Bot Name',
        'Created',
        'Started',
        'Last Interaction',
        'Total Requests',
        'Resolved Requests',
        'Unassigned Requests',
        'Expired Requests',
        'Average Resolve Time',
        'Video Sessions',
        'Voice Sessions',
        'App to Phone Sessions'
    ]
    const currentAgentHeadingKeys = [
        'botId',
        'createdAt',
        'firstRequestTime',
        'lastRequestTime',
        'totalRequests',
        'resolvedRequests',
        'unassignedRequests',
        'expiredRequests',
        'resolveTime',
        'videoSessions',
        'audioOnlySessions',
        'voiceSessions',
        'linkedAgent'
    ]
    const workspaceHeading = [
        'Agent ID',
        'Created',
        'Bots Linked',
        'Total Requests',
        'Resolved Requests',
        'Unassigned Requests',
        'Expired Requests',
        'Average Resolve Time',
        'Video Sessions',
        'Voice Sessions',
        'App to Phone Sessions'
    ]
    const workspaceHeadingKeys = [
        'email',
        'createdAt',
        'botsLinked',
        'totalRequests',
        'resolvedRequests',
        'unassignedRequests',
        'expiredRequests',
        'resolveTime',
        'videoSessions',
        'audioOnlySessions',
        'voiceSessions'
    ]

    const Bar1data = [
        {
            name: 'Agents',
            Value1: livePerformanceMatrics.linkedAgents,
            Value2: livePerformanceMatrics.unlinkedAgents,
            Value1Color: '#8884d8',
            Value2Color: '#82ca9d'
        },
        {
            name: 'Bots',
            Value1: livePerformanceMatrics.linkedBots,
            Value2: livePerformanceMatrics.unlinkedBots,
            Value1Color: '#8884d8',
            Value2Color: '#82ca9d'
        },
        {
            name: 'Sessions',
            Value1: livePerformanceMatrics.avgLiveSessions,
            Value1Color: '#8884d8'
        },
    ]

    const Bar2data = [
        {
            name: 'Available',
            value1: 24,
            Value1Color: '#43A047'
        },
        {
            name: 'Engaged',
            value1: 20,
            Value1Color: '#FB8C00'
        },
        {
            name: 'Offline',
            value1: 2,
            Value1Color: '#a8a6a3'
        },
    ]

    const AgentPerformanceColors = {
        totalRequests: '#FFD700',    // Light Gold
        resolvedRequests: '#90EE90', // Light Green
        unassignedRequests: '#ADD8E6', // Light Blue
        expiredRequests: '#FFB6C1', // Light Pink
        resolveTime: '#FFA07A',     // Light Salmon
        videoSessions: '#E6E6FA',   // Light Lavender
        voiceSessions: '#FFFACD'    // Light Lemon Chiffon
    }

    const performanceDefaultColor = '#8884d8'
    const performanceBackgroundColor = '#eee'

    const BotPerformanceColors = {
        totalRequests: '#FFD700',    // Light Gold
        resolvedRequests: '#90EE90', // Light Green
        unassignedRequests: '#ADD8E6', // Light Blue
        expiredRequests: '#FFB6C1', // Light Pink
        resolveTime: '#FFA07A',     // Light Salmon
        videoSessions: '#E6E6FA',   // Light Lavender
        voiceSessions: '#FFFACD'    // Light Lemon Chiffon
    }

    let renderLabel = function (entry) {
        // console.log(entry)
        // return entry.name;
        const value = Math.round(entry.percent * 100)
        return `${entry.name}(${value}%)`
    }

    const renderLegend = (props) => {
        const { payload } = props
        return (
            <ul className={style.legendItems}>
                {
                    payload.map((entry, index) => (
                        <li className={style.legendItem} key={`item-${index}`}><div className={style.legendNode} style={{ background: performanceDefaultColor }}></div>{performanceMatricsList[entry.value]}</li>
                    ))
                }
            </ul>
        )
    }

    const data = [
        {
            'name': 'Mon',
            'value': 24
        },
        {
            'name': 'Tue',
            'value': 22
        },
        {
            'name': 'Wed',
            'value': 22
        },
        {
            'name': 'Thu',
            'value': 2
        },
        {
            'name': 'Fri',
            'value': 18
        },
        {
            'name': 'Sat',
            'value': 5
        },
        {
            'name': 'Sun',
            'value': 10
        }
    ]


    const AgentWeekReport = {
        table: 'Metrics',
        data: [
            {
                key: 'Fastest Response',
                value: 'Tuesday'
            },
            {
                key: 'Longest Response',
                value: 'Saturday'
            },
        ]
    }

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            const labelInfo = payload[0].payload
            // console.log('labelInfo: ', labelInfo)
            return (
                <div className={style.customToolTip}>
                    <p className={style.maiLabel}>{label}</p>
                    {/* <p className={style.desc}>Anything you want can be displayed here.</p> */}
                    {/* <p className={style.label1}><b style={{color: labelInfo.Value1Color}}>{`${label} : ${labelInfo.value1}`}</b></p>
                    <p className={style.label1}><b style={{color: labelInfo.Value1Color}}>{`${label} : ${labelInfo.value1}`}</b></p> */}
                </div>
            )
        }

        return null
    }


    return (
        <PageContainer title="Dashboard" contentClassName="dashboard-no-margin">
            <style>
                {`
                    .dashboard-no-margin {
                        margin: 10px auto !important;
                    }
                `}
            </style>
            <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '10px', marginTop: '-20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontFamily: 'Barlow Medium', fontSize: '24px', paddingLeft: '0px' }}>
                            My Dashboard
                        </span>
                    </div>
                </div>

                <div className={style.agentAnalyticsSectionContainer}>
                    {/* Session Count Widgets - First Row */}
                    <div style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
                        <div style={{ flex: '1 1 25%', minHeight: '120px' }}>
                            <StatWidget
                                icon={<SessionsIcon />}
                                value={agentDashboardData.todaySessionCount}
                                label="Today Session Count"
                            />
                        </div>
                        <div style={{ flex: '1 1 25%', minHeight: '120px' }}>
                            <StatWidget
                                icon={<SessionsIcon />}
                                value={agentDashboardData.lastWeekSessionCount}
                                label="Last Week Session Count"
                            />
                        </div>
                        <div style={{ flex: '1 1 25%', minHeight: '120px' }}>
                            <StatWidget
                                icon={<SessionsIcon />}
                                value={agentDashboardData.last30DaysSessionCount}
                                label="Last 30 Days Session Count"
                            />
                        </div>
                        <div style={{ flex: '1 1 25%', minHeight: '120px' }}>
                            <StatWidget
                                icon={<BotIcon />}
                                value={agentDashboardData.totalBots}
                                label="Total Bots"
                            />
                        </div>
                    </div>

                    {/* Agent Performance Report and Bot Activity Comparison */}
                    <div style={{
                        display: 'flex',
                        gap: '30px',
                        marginBottom: '30px',
                        alignItems: 'stretch',
                    }}>
                        {/* Agent Performance Report */}
                        <div style={{
                            flex: 1,
                            background: 'white',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.07)',
                            padding: '28px 28px 20px 28px',
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: 0
                        }}>
                            <style>
                                {`
                                    .agent-performance-report table {
                                        border-collapse: collapse;
                                    }
                                    .agent-performance-report table th,
                                    .agent-performance-report table td {
                                        border: 1px solid #e0e0e0;
                                        padding: 8px 12px;
                                    }
                                    .agent-performance-report table th {
                                        background-color: #f8f8fa;
                                        font-weight: bold;
                                        border-bottom: 2px solid #d0d0d0;
                                    }
                                    .agent-performance-report table tr:nth-child(even) {
                                        background-color: #fafafa;
                                    }
                                    .agent-performance-report table tr:hover {
                                        background-color: #f5f5f5;
                                    }
                                `}
                            </style>
                            <div className="agent-performance-report">
                                <TableContainer
                                    data={selectedAgentStatsData}
                                    botNames={botNames}
                                    tableValueHeading='Value'
                                />
                            </div>
                        </div>

                        {/* Bot Activity Comparison */}
                        <div style={{
                            flex: 1,
                            background: 'white',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.07)',
                            padding: '28px 28px 20px 28px',
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: 0
                        }}>
                            <PerformanceGraph
                                type='botPerformance'
                                heading='Bot activity'
                                dataKey='botName'
                                agentsStatsData={selectedAgentStatsData}
                                performanceMatricsList={performanceMatricsList}
                                botNames={botNames}
                                defaultColor={performanceDefaultColor}
                                backgroundColor={performanceBackgroundColor}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </PageContainer>
    )
}

const mapStateToProps = (state: AppState) => ({
    agentsStatsData: state.collaborators.agentsStatsData,
    bots: state.bots.bots,
    botsByAgent: state.bots.botsByAgent,
    users: state.collaborators.users
})

const connector = connect(mapStateToProps, { fetchAgentsStatsData, toggleAnalyticsWindow, fetchBots })

export default connector(ReportingModal)
